import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public isCollapsed = false;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/header/header.component.ts